// Acceso VIGENTE de un usuario en la configuración simple: las sedes que hoy ve en
// inmatriculaciones según la regla de su grupo (Seguridad las calcula en
// `sedes_vigentes`). Al pasar a "Por organización" el modal parte de ellas.

/** Sedes vigentes del usuario, o null si Seguridad no las informó. */
export const sedesVigentes = (usuario: any): number[] | null => {
    const lista = Array.isArray(usuario?.sedes_vigentes)
        ? usuario.sedes_vigentes.map(Number).filter(Number.isInteger)
        : []
    return lista.length ? lista : null
}

/** true si las dos listas tienen las mismas sedes, sin importar el orden. */
export const mismasSedes = (a: number[], b: number[]) => {
    const unicas = new Set(a)
    return unicas.size === new Set(b).size && b.every((c) => unicas.has(c))
}
